<img
  src="assets/shared/global-images/icon-set/copy-white.svg"
  alt=""
/>
<span
  payee-ripple
  class="payee-round-button-ripple"
  [payeeRippleDisabled]="disableRipple"
  [payeeRippleTrigger]="element"
  [attr.color]="color"
></span>
